import { ROUTES } from '@constants/ROUTES';
import { PAGE_TABS_DATA } from '@constants/scholarships';

import { PLAN_CARD } from '@interfaces/nonLearnerHomePage';

import MajorsIcon from '@images/pulpit.svg?react';
import SchoolsIcon from '@images/graduate-cap.svg?react';
import BillIcon from '@images/bill.svg?react';
import CommonAppIcon from '@images/common-app-logo.svg?react';
import ChecklistIcon from '@images/checklist.svg?react';
import MaskIcon from '@images/mask.svg?react';
import { CARD_IDS } from './baseHomePage';

export const EDUCATION_OPPORTUNITIES_CARDS = [
  {
    id: CARD_IDS.MAJORS,
    icon: <MajorsIcon />,
    title: 'Programs/Majors',
    description: 'Find programs/majors to get you into the career you want.',
    favoriteLink: ROUTES.FAVORITE_MAJORS,
    startExploringLink: ROUTES.MAJORS,
  },
  {
    id: CARD_IDS.SCHOOLS,
    icon: <SchoolsIcon />,
    title: 'Schools',
    description: 'Find a university, community, or technical college that work for you and your chosen career field.',
    favoriteLink: ROUTES.FAVORITE_SCHOOLS,
    startExploringLink: ROUTES.SCHOOLS,
  },
  {
    id: CARD_IDS.SCHOLARSHIPS,
    icon: <BillIcon />,
    title: 'Scholarships',
    description:
      'Discover the scholarship that best fits your goals. You can save scholarships to your favorites or apply directly through their website.',
    favoriteLink: `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.favorites.hash}`,
    startExploringLink: `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.allScholarships.hash}`,
  },
];

export const PLAN_FOR_COLLEGE_CARDS: PLAN_CARD[] = [
  {
    id: CARD_IDS.EDUCATION_PLANNER,
    icon: <ChecklistIcon />,
    title: 'College planning',
    navigationUrl: ROUTES.EDUCATION_PLANNER,
  },
  {
    id: CARD_IDS.RECOMMENDER_SPACE,
    icon: <CommonAppIcon />,
    title: 'Common App applicants',
    navigationUrl: ROUTES.RECOMMENDER_SPACE,
  },
  {
    id: CARD_IDS.EDUCATION_PLANNER_APPLICATIONS,
    icon: <MaskIcon />,
    title: 'College applications',
    navigationUrl: ROUTES.EDUCATION_PLANNER_APPLICATIONS,
  },
];
